export const IconThumbsDownFill = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1892 10.1182C12.1892 10.5324 12.525 10.8682 12.9392 10.8682L14.9014 10.8682C15.3156 10.8682
    15.6514 10.5324 15.6514 10.1182L15.6514 1.64749C15.6514 1.23327 15.3156 0.897488 14.9014 0.897488L12.9392
    0.897487C12.525 0.897487 12.1892 1.23327 12.1892 1.64749L12.1892 10.1182Z"
      fill="currentColor"
    />
    <path
      d="M5.02294 0.928799L5.05594 0.930784C8.54301 1.14026 9.06357 2.04239 10.9966 2.3105L10.9966
    9.8639C10.9065 9.94221 10.8133 10.0285 10.7135 10.1235C9.68328 11.1036 9.06661 12.2161 9.06661 13.8345C9.06661
    16.0911 6.12134 15.0345 6.12134 13.0212L6.12134 10.4279C6.12134 9.69149 5.52434 9.09452 4.78801 9.09452L1.68688
    9.09452C0.0504098 9.09452 0.619145 3.95005 2.30635 1.78678C3.06726 0.811204 3.88658 0.86047 5.02294 0.928799Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
